module.exports = __webpack_public_path__ + "img/coupon_four.6fdd46e3.webp";